export function evalCond(c, data, meta, item) {
  if (!c) return true;
  if (c.all) return c.all.every((x) => evalCond(x, data, meta, item));
  if (c.any) return c.any.some((x) => evalCond(x, data, meta, item));
  const k = c.f;
  const v = k.startsWith("$") ? meta[k] : k.startsWith("@") ? (item || {})[k.slice(1)] : data[k];
  if ("eq" in c) return v === c.eq;
  if ("ne" in c) return v !== c.ne;
  if ("in" in c) return c.in.includes(v);
  if ("nin" in c) return !c.nin.includes(v);
  if ("truthy" in c) return Boolean(v) === c.truthy;
  if ("has_any" in c) return (v || []).some((x) => c.has_any.includes(x));
  return true;
}

export function buildMeta(app, provider) {
  const variants = (provider || {})[`${app.kind}_variants`] || [];
  const v = variants.find((x) => x.code === app.data["app.variant"]);
  return {
    $entity: app.entity_type || app.data["biz.entity_type"], $kind: app.kind,
    $supports_joint: Boolean(provider?.supports_joint), $variant_funding: Boolean(v && v.min_funding),
  };
}

export function isRequired(f, data, meta, item) {
  if (!evalCond(f.show, data, meta, item)) return false;
  if (["heading", "readonly"].includes(f.type)) return false;
  if (f.req_if) return evalCond(f.req_if, data, meta, item);
  return f.req;
}
